/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_Stop_WatchingInputs */

const en_directory_card_stop_watching = /** @type {(inputs: Directory_Card_Stop_WatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop watching product`)
};

const zh_directory_card_stop_watching = /** @type {(inputs: Directory_Card_Stop_WatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消关注`)
};

/**
* | output |
* | --- |
* | "Stop watching product" |
*
* @param {Directory_Card_Stop_WatchingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_stop_watching = /** @type {((inputs?: Directory_Card_Stop_WatchingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Stop_WatchingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_stop_watching(inputs)
	return zh_directory_card_stop_watching(inputs)
});
export { directory_card_stop_watching as "directory.card.stop_watching" }